/** @format */

import { Provider } from "react-redux";
import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";

import store from "../../redux/store";
import NotFound from "../notfound/NotFound";
import MainLayout from "./layout/MainLayout";
import Aqllisuv from "./pages/aqllisuv/AqlliSuv";
import Dashboard from "./pages/Dashboard/Dashboard";
import LimitSahifa from "./pages/limitlar/LimitSahifa";
import ReykauchqorgonSahifa from "./pages/reka02/Reka02";
import OqjarqizilqishloqSahifa from "./pages/oqjar/Oqjar";
import RavotxojiSahifa from "./pages/ravotxoji/Ravotxoji";
import SuvomborlariSahifa from "./pages/suvomborlar/index";
import { user_data } from "../../components/functions/usr";
import AmudaryoSahifa from "./pages/balans/amudaryo/AmudaryoSahifa";
import SirdaryoSahifa from "./pages/balans/sirdaryo/SirdaryoSahifa";
import StatistikhisobotSahifa from "./pages/StatistikhisobotSahifa";
import SuvdanfoydalanishSahifa from "./pages/suvdanfoydalanish/index";
import ZarafshonSahifa from "./pages/balans/zarafshon/ZarafshonSahifa";
import AsosiymanbalarSahifa from "./pages/asosiymanbalar/AsosiyManbalar";
import VegetatsiyaSahifa from "./pages/sugorish/vegetatsiya/VegetatsiyaSahifa";
import NovegetatsiyaSahifa from "./pages/sugorish/novegetatsiya/NovegetatsiyaSahifa";

function Index() {
  const region = user_data() ? user_data().region_id : 1;
  const itb = user_data() ? user_data().itb_id : 1;
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

    console.log(itb)

  return (
    <Provider store={store}>
      <Routes>
          <Route element={<MainLayout date={date} setDate={setDate} />}>
            <Route index element={<Dashboard regionId={region} date={date} />} />
            <Route path='suvomborlari/*' element={<SuvomborlariSahifa />} />
            <Route path='aqllisuv/*' element={<Aqllisuv />} />
            <Route path='amudaryo' element={<AmudaryoSahifa />} />
            <Route path='sirdaryo' element={<SirdaryoSahifa />} />
            <Route path='zarafshon' element={<ZarafshonSahifa />} />
            <Route path='suvdanfoydalanish/*' element={<SuvdanfoydalanishSahifa />} />
            <Route path='asosiymanbalar/*' element={<AsosiymanbalarSahifa />} />
            <Route path='ravotxoji/*' element={<RavotxojiSahifa />} />
            <Route path='oqjarqizilqishloq/*' element={<OqjarqizilqishloqSahifa />} />
            <Route path='reykauchqurgon/*' element={<ReykauchqorgonSahifa />} />
            <Route path='limit/*' element={<LimitSahifa />} />
            <Route path='vegitatsiya/*' element={<VegetatsiyaSahifa />} />
            <Route path='novegitatsiya/*' element={<NovegetatsiyaSahifa />} />
            <Route path='statistik' element={<StatistikhisobotSahifa />} />
          </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Provider>
  );
}

export default Index;
